import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonDropdown } from '@dossierhq/design';
import { useCallback } from 'react';
import { SearchEntityStateActions, } from '../../reducers/SearchEntityReducer/SearchEntityReducer.js';
const items = [
    { id: '25', count: 25 },
    { id: '50', count: 50 },
    { id: '75', count: 75 },
    { id: '100', count: 100 },
];
export function SampleEntitiesOptionsCount({ searchEntityState, dispatchSearchEntityState, }) {
    const { requestedCount } = searchEntityState;
    const handleCountChange = useCallback((item) => {
        dispatchSearchEntityState(new SearchEntityStateActions.SetSampling({ count: item.count }, true));
    }, [dispatchSearchEntityState]);
    const currentPage = searchEntityState.entitySamples && searchEntityState.entitySamples.items.length > 0
        ? `${searchEntityState.entitySamples.items.length} of ${searchEntityState.entitySamples.totalCount}`
        : requestedCount;
    return (_jsx(ButtonDropdown, { up: true, sneaky: true, activeItemIds: [String(requestedCount)], items: items, renderItem: (item) => item.count, onItemClick: handleCountChange, children: currentPage }));
}
//# sourceMappingURL=SampleEntitiesOptionsCount.js.map